import React, { useEffect, useState } from "react";
import Modal from "components/modal/Modal";
import { MdDelete } from "react-icons/md";
import { updateUser, deleteUser } from "api";
import InputField from "components/fields/InputField";
import Dropdown from "components/dropdown";

const EditUserModal = ({ user, onClose, mentors = [], teams = [] }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    username: "",
    phoneNumber: "",
    country: "",
    school: "",
    enrollmentYear: "",
    teamRole: "",
    status: "Offline",
    role: "user",
    mentorId: "",
    teamId: "",
  });

useEffect(() => {
  if (user) {
    console.log("🔍 Full user object:", user); // ✅ Place it here

    const nameArray = Array.isArray(user.name) ? user.name : [];
    let firstName = "";
    let lastName = "";
    let username = user.username ?? "";

    if (typeof nameArray[0] === "string" && nameArray[0].trim().includes(" ")) {
      const [first, ...rest] = nameArray[0].trim().split(" ");
      firstName = first ?? "";
      lastName = rest.join(" ") ?? "";
    } else {
      firstName = nameArray[0] ?? "";
      lastName = nameArray[1] ?? "";
    }

    if (!username && typeof nameArray[2] === "string") {
      username = nameArray[2];
    }

    username = username ?? "";

    const formPayload = {
      firstName,
      lastName,
      username,
      email: user.email ?? "",
      phoneNumber: user.phoneNumber ?? "",
      country: user.country ?? "",
      school: user.school ?? "",
      enrollmentYear: user.enrollmentYear ?? "",
      teamRole: user.teamRole ?? "",
      status: user.status ?? "Offline",
      role: user.role ?? "user",
      mentorId: user.mentorId ?? "",
      teamId: user.teamId ?? "",
    };

    console.log("📋 Form data set:", formPayload); // Optional: See final payload
    setFormData(formPayload);
  }
}, [user]);


  const handleSave = async () => {
    try {
      const updatedUser = {
        ...user,
        ...formData,
      };
      console.log("Updating user with:", updatedUser);
      await updateUser(user.id, updatedUser);
      onClose();
    } catch (error) {
      console.error("Error updating user:", error);
    }
  };

  const handleDelete = async () => {
    if (window.confirm("Are you sure you want to delete this user?")) {
      try {
        await deleteUser(user.id);
        onClose();
      } catch (error) {
        console.error("Error deleting user:", error);
      }
    }
  };

  return (
    <Modal onClose={onClose}>
      <div className="custom-scrollbar p-6 bg-white rounded-lg shadow-md dark:bg-navy-800 max-h-[80vh] overflow-y-auto">
        <style>
          {`
            .custom-scrollbar::-webkit-scrollbar {
              width: 8px;
            }
            .custom-scrollbar::-webkit-scrollbar-track {
              background: transparent;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb {
              background-color: rgba(222, 222, 222, 0.2);
              border-radius: 6px;
              transition: background-color 0.2s ease-in-out;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb:hover {
              background-color: rgba(222, 222, 222, 0.4);
            }
            .dark .custom-scrollbar::-webkit-scrollbar-thumb {
              background-color: rgba(74, 85, 104, 0.5);
            }
            .dark .custom-scrollbar::-webkit-scrollbar-thumb:hover {
              background-color: rgba(74, 85, 104, 0.7);
            }
          `}
        </style>

        <h3 className="text-xl font-bold text-navy-700 dark:text-white mb-4">Edit User</h3>

        <div className="space-y-4">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <InputField label="First Name" value={formData.firstName} onChange={(e) => setFormData({ ...formData, firstName: e.target.value })} />
            <InputField label="Last Name" value={formData.lastName} onChange={(e) => setFormData({ ...formData, lastName: e.target.value })} />
            <InputField label="Email" type="email" value={formData.email} onChange={(e) => setFormData({ ...formData, email: e.target.value })} />
            <InputField label="Username" value={formData.username} onChange={(e) => setFormData({ ...formData, username: e.target.value })} />
            <InputField label="Phone Number" value={formData.phoneNumber} onChange={(e) => setFormData({ ...formData, phoneNumber: e.target.value })} />
            <InputField label="Country" value={formData.country} onChange={(e) => setFormData({ ...formData, country: e.target.value })} />
            <InputField label="School" value={formData.school} onChange={(e) => setFormData({ ...formData, school: e.target.value })} />
            <InputField label="Enrollment Year" value={formData.enrollmentYear} onChange={(e) => setFormData({ ...formData, enrollmentYear: e.target.value })} />
            <InputField label="Team Role" value={formData.teamRole} onChange={(e) => setFormData({ ...formData, teamRole: e.target.value })} />
          </div>

          <Dropdown
            label="Status"
            variant="manage"
            button={
              <button className="py-2 px-4 w-full text-left rounded-md border border-gray-300 dark:bg-navy-900 dark:text-white">
                {formData.status}
              </button>
            }
            classNames="bg-white shadow-lg rounded-md mt-1"
          >
            {["Online", "Offline", "Busy", "Away"].map((option) => (
              <button
                key={option}
                onClick={() => setFormData({ ...formData, status: option })}
                className="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-navy-700"
              >
                {option}
              </button>
            ))}
          </Dropdown>

          <Dropdown
            label="Role"
            variant="manage"
            button={
              <button className="py-2 px-4 w-full text-left rounded-md border border-gray-300 dark:bg-navy-900 dark:text-white">
                {formData.role}
              </button>
            }
            classNames="bg-white shadow-lg rounded-md mt-1"
          >
            {["user", "mentor", "admin"].map((option) => (
              <button
                key={option}
                onClick={() => setFormData({ ...formData, role: option })}
                className="block w-full text-left px-4 py-2 hover:bg-gray-100 dark:hover:bg-navy-700"
              >
                {option}
              </button>
            ))}
          </Dropdown>

          <div>
            <label className="block mb-1 font-medium text-sm text-gray-700 dark:text-white">Mentor</label>
            <select
              className="w-full p-2 border rounded-md dark:bg-navy-900 dark:text-white"
              value={formData.mentorId}
              onChange={(e) => setFormData({ ...formData, mentorId: e.target.value })}
            >
              <option value="">No mentor</option>
              {mentors.map((mentor) => (
                <option key={mentor.id} value={mentor.id}>
                  {mentor.firstName} {mentor.lastName} ({mentor.username})
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block mb-1 font-medium text-sm text-gray-700 dark:text-white">Team</label>
            <select
              className="w-full p-2 border rounded-md dark:bg-navy-900 dark:text-white"
              value={formData.teamId}
              onChange={(e) => setFormData({ ...formData, teamId: e.target.value })}
            >
              <option value="">No team</option>
              {teams.map((team) => (
                <option key={team.id} value={team.id}>
                  {team.name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="mt-6 flex justify-between items-center">
          <button
            className="flex items-center rounded-xl bg-red-500 px-4 py-3 text-sm font-medium text-white transition duration-200 hover:bg-red-600 active:bg-red-700 dark:bg-red-400 dark:text-white dark:hover:bg-red-300 dark:active:bg-red-200"
            onClick={handleDelete}
          >
            <MdDelete className="mr-2" />
            Delete
          </button>
          <div className="flex space-x-4">
            <button
              className="rounded-lg bg-gray-200 py-2 px-4 text-sm font-medium text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 transition duration-200"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="flex items-center rounded-xl bg-orange-500 px-4 py-3 text-sm font-medium text-white transition duration-200 hover:bg-orange-600 active:bg-orange-700 dark:bg-orange-400 dark:text-white dark:hover:bg-orange-300 dark:active:bg-orange-200"
              onClick={handleSave}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default EditUserModal;
